import React from "react";
import HoursReviewTable from "./HoursReviewTable/index"
import { getUserPreference } from "../../../utilities/common";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { TextField, Button, Grid, MenuItem, makeStyles, IconButton } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import _ from "lodash";
import {
    getPaymentCycle,
    searchHoursReivewDetails,
    approveDailyLog
} from "../../../actions/payRollAdjustmentAction";

const useStyles = makeStyles((theme) => ({
    grid: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'right',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(1), // 调整上方间距
        marginBottom: theme.spacing(1), // 调整下方间距
    },
    textField: {
        width: '100%',
    },
    Button: {
        marginTop: theme.spacing(2), // 调整上方间距
        display: 'flex',
        alignItems: 'right',
        marginRight: theme.spacing(-7),
    },
    searchButton: {
        backgroundColor: 'gray',
        color: 'white',
        '&:hover': {
            backgroundColor: 'darkgray',
        },
    },
    refreshButton: {
        backgroundColor: 'gray',
        color: 'white',
        '&:hover': {
            backgroundColor: 'darkgray',
        },
    },
    icon: {
        width: '21.9px',
        height: '21.9px',
    },
}));

function PayrollHoursReview() {
    const { t } = useTranslation('payrollAdjustment');
    const dispatch = useDispatch();
    const classes = useStyles();
    const userPref = getUserPreference();
    const [selectedItem, setSelectedItem] = useState();
    const [houReviewDeatils, setHourReviewDeatils] = useState([]);
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [timezone, setTimezone] = useState('');
    const [driverId, setDriverId] = useState("");
    const [payrollCycle, setPayrollCycle] = useState();
    const [currentPayCycle, setCurrentPayCycle] = useState("");

    const [status, setStatus] = useState(1);

    const handleSearch = () => {
        setIsDataLoading(true);
        const params = {
            payment_cycle: currentPayCycle,
            warehouse: userPref.userCity,
        };

        if (!_.isNil(driverId) && driverId !== "") {
            params.driver_id = driverId;
        }

        if (!_.isNil(status) && status !== "") {
            params.status = status;
        }

        dispatch(searchHoursReivewDetails(params))
            .then((response) => {
                setHourReviewDeatils(response);
                dispatch(showAlertSnackbar({
                    title: t('hours_review'),
                    message: t('dialog:hours_review_search_success'),
                    type: 'success'
                }));
            })
            .catch((error) => {
                dispatch(showAlertSnackbar({
                    title: t('hours_review'),
                    message: t('dialog:hours_review_search_failed'),
                    type: 'success'
                }));
                setHourReviewDeatils([]);  // Clear the table data
                setSelectedItem('');
            })
            .finally(() => {
                setIsDataLoading(false);
            });
    };

    const handleApproveSubmit = () => {
        const params = {
            payment_cycle: currentPayCycle,
            warehouse: userPref.userCity,
        };

        if (!_.isNil(selectedItem) && selectedItem.length > 0) {
            params.driver_id = selectedItem.map(item => item.id).join(',');
        }

        dispatch(approveDailyLog(params))
            .then((response) => {
                dispatch(showAlertSnackbar({
                    title: t('hours_review'),
                    message: t('dialog:hours_review_approve_success'),
                    type: 'success'
                }));
                setHourReviewDeatils([]);  // Clear the table data
                setSelectedItem('');
            })
            .catch((error) => {
                dispatch(showAlertSnackbar({
                    title: t('hours_review'),
                    message: t('dialog:hours_review_approve_failed'),
                    type: 'error'
                }));
            });
    };

    const handleSelectedItems = (items) => {
        setSelectedItem(items);
    }

    const handleStatusChange = (event) => {
        setStatus(event.target.value);
    };

    const handleCurrentPayrollCycleChange = (event) => {
        setCurrentPayCycle(event.target.value);
    };

    const handleDriverIdChange = (event) => {
        setDriverId(event.target.value);
    };

    const statusList = [
        {
            id: 1,
            text: t('to_be_reviewed'),
            value: 1
        },
        {
            id: 2,
            text: t('approval'),
            value: 2
        }
    ];

    useEffect(() => {
        const branchTimezone = _.filter(
            Object.values(JSON.parse(window.localStorage.getItem('branches'))), (item) => {
                return item.city === parseInt(window.localStorage.getItem('user_city'));
            })
        if (!_.isEmpty(branchTimezone)) {
            setTimezone(branchTimezone[0]?.time_zone)
        }
        dispatch(getPaymentCycle())
            .then((res) => {
                setPayrollCycle(res);
            })
            .catch(() => {
                setIsDataLoading(false);
            })
            .finally(() => {
            })
    }, []);

    return (
        <>
            <Grid container spacing={0}>
                <Grid item xs={2} className={classes.grid}>
                    <TextField
                        id="hoursreivew_paycycle_textfield"
                        label={t('payment_cycle')}
                        value={currentPayCycle}
                        fullWidth
                        onChange={handleCurrentPayrollCycleChange}
                        className={classes.textField}
                        select
                    >
                        {payrollCycle && [
                            <MenuItem key={1} value={payrollCycle.currentPayrollCycles}>
                                {`Current: ${payrollCycle.currentPayrollCycles}`}
                            </MenuItem>,
                            <MenuItem key={2} value={payrollCycle.nextPayrollCycle}>
                                {`Next Payroll: ${payrollCycle.nextPayrollCycle}`}
                            </MenuItem>,
                            <MenuItem key={3}>
                                {'Last Three Months:'}
                            </MenuItem>,
                            ...payrollCycle.lastThreeMonthPayrollCycles.map((cycle, index) => (
                                <MenuItem key={index + 4} value={cycle}>
                                    {cycle}
                                </MenuItem>
                            )),
                        ]}
                    </TextField>
                </Grid>
                <Grid item xs={1} className={classes.grid}>
                    <TextField
                        id="hoursreivew_status_textfield"
                        label={t('status')}
                        value={status}
                        onChange={handleStatusChange}
                        fullWidth
                        className={classes.textField}
                        select // Add the select attribute to render as a select field
                    >
                        {statusList.map((item) => (
                            <MenuItem key={item.id} value={item.value}>
                                {t(item.text)}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={1} className={classes.grid}>
                    <TextField
                        id="hoursreivew_dirverid_textfield"
                        label={t("driver_id")}
                        value={driverId}
                        onChange={handleDriverIdChange}
                        fullWidth
                        className={classes.textField}
                    />
                </Grid>
                <Grid item xs={0.5} className={classes.grid}>
                    <IconButton id="hoursreivew_searchButton_iconbutton" color="primary" className={classes.searchButton} onClick={handleSearch}
                    >
                        <Search className={classes.icon} />
                    </IconButton>
                </Grid>
                <Grid item xs={6} className={classes.grid}>
                    <Button
                        id="hoursreivew_approve_button"
                        variant="contained"
                        color="primary"
                        className={classes.Button}
                        disabled={!selectedItem || selectedItem.length === 0 || parseInt(status) === 2}
                        onClick={handleApproveSubmit}
                    >
                        {t('approve')}
                    </Button>
                </Grid>
                <Grid item xs={12} >
                    <HoursReviewTable
                        houReviewDeatils={houReviewDeatils}
                        isDataLoading={isDataLoading}
                        setSelectedItems={handleSelectedItems}
                        timezone={timezone}
                    />
                </Grid>
            </Grid>
        </>
    );
}

export default PayrollHoursReview;
